import UnAuthBg from './images/bg/unAuthBG.png';
import FMSLogo from './images/fleet-management.png';

const Images = {
    UnAuthBg,
    FMSLogo,
};
export default Images;
